import React from 'react'
import reportWebVitals from './reportWebVitals'
import ReactDOM from 'react-dom/client'
import '@styles/newPostQuill.css'
import '@styles/animations.css'
import '@styles/keyframes.css'
import '@styles/global.css'
import Providers from '@components/base/Providers'
import Routes from '@components/base/Routes'

// Lock scren orientation to portrait
// window.screen.orientation.lock('portrait')

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Providers>
    <Routes />
  </Providers>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
